import {
  BookOpenIcon,
  BookmarkIcon,
  CalendarCheckIcon,
  CalendarClockIcon,
  CalendarDaysIcon,
  CalendarIcon,
  CircleHelpIcon,
  ClipboardListIcon,
  ClockIcon,
  FileIcon,
  FileTextIcon,
  FolderIcon,
  LightbulbIcon,
  MegaphoneIcon,
  MessageCircleIcon,
  MessageSquareIcon,
  MessagesSquareIcon,
  NewspaperIcon,
  NotebookTextIcon,
  UsersIcon,
} from "lucide-react";

import { IconData } from "../ui/icon";

export const SIDEBAR_ICONS = {
  file: FileIcon,
  "file-text": FileTextIcon,
  "book-open": BookOpenIcon,
  newspaper: NewspaperIcon,
  "clipboard-list": ClipboardListIcon,
  folder: FolderIcon,
  "notebook-text": NotebookTextIcon,
  bookmark: BookmarkIcon,
  "circle-help": CircleHelpIcon,
  lightbulb: LightbulbIcon,
  "messages-square": MessagesSquareIcon,
  "message-square": MessageSquareIcon,
  "message-circle": MessageCircleIcon,
  megaphone: MegaphoneIcon,
  users: UsersIcon,
  calendar: CalendarIcon,
  "calendar-days": CalendarDaysIcon,
  "calendar-check": CalendarCheckIcon,
  "calendar-clock": CalendarClockIcon,
  clock: ClockIcon,
} as const satisfies Record<string, IconData>;
